// extracted by mini-css-extract-plugin
export default {"link":"PhoneTo_link__xQqVH"};